@if (fields?.length > 0) {
  <div class="dimensions-form box-form mat-elevation-z3">
    <form [formGroup]="dimensionsForm">
      @for (field of fields; track field) {
        @if (field.name == 'standardHeight' && field.type === 'checkbox') {
          <mat-checkbox
            [checked]="isStandardHeightSelected()"
            (change)="toggleStandardHeightField($event)"
            >{{ 'DOOR|Standardowa wysokość' | translate }}
          </mat-checkbox>
        }
        @if (field.field && field.type === 'number') {
          <mat-form-field appearance="outline">
            @if (field.name == 'sashSize') {
              <mat-label translate>DOOR|Rozmiar skrzydła</mat-label>
            }
            @if (field.name == 'passiveSashSize') {
              <mat-label translate>DOOR|Rozmiar skrzydła biernego</mat-label>
            }
            @if (field.name == 'topLightSize') {
              <mat-label>{{ 'DOOR|Wysokość doświetla górnego:' | translate }}</mat-label>
            }
            @if (field.name == 'leftLightSize') {
              <mat-label>{{ 'DOOR|Szerokość doświetla lewego:' | translate }}</mat-label>
            }
            @if (field.name == 'rightLightSize') {
              <mat-label>{{ 'DOOR|Szerokość doświetla prawego:' | translate }}</mat-label>
            }
            @if (field.name == 'customWidth') {
              <mat-label>{{ 'DOOR|Szerokość drzwi:' | translate }}</mat-label>
            }
            @if (field.name == 'customHeight') {
              <mat-label>{{ 'DOOR|Wysokość drzwi:' | translate }}</mat-label>
            }
            <input
              matInput
              [iccNumberInputInteger]="true"
              iccDimensionInput
              type="number"
              [formControlName]="field.field"
              [min]="getMin(field)"
              [max]="getMax(field)"
              [step]="field.step || 1"
              [disabled]="field.disabled"
              iccNumberInput
              />
              <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
              @if (field.hintParams) {
                <mat-hint >{{ 'DOOR|Wartość powinna mieścić się w zakresie od {min} do {max} ze skokiem co {step}' | translate: field.hintParams }}</mat-hint>
              }
              <mat-error>
                @if (dimensionsForm.get(field.field).errors?.range) {
                  <span>
                    {{ 'DOOR|Wartość powinna mieścić się w zakresie od {min} do {max} ze skokiem co {step}' | translate: dimensionsForm.get(field.field).errors?.range }}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          }
          @if (field.field && field.options.length > 0 && field.type === 'select') {
            <mat-form-field appearance="outline">
              @if (field.name == 'sashSize') {
                <mat-label translate>DOOR|Rozmiar skrzydła</mat-label>
              }
              @if (field.name == 'passiveSashSize') {
                <mat-label translate>DOOR|Rozmiar skrzydła biernego</mat-label>
              }
              @if (field.name == 'shortening') {
                <mat-label>{{ (seperateFrameAndSashShortening$ | async) ? ('DOOR|Skracanie skrzydła:' | translate) : ('DOOR|Skracanie:' | translate) }}</mat-label>
              }
              @if (field.name == 'frameShortening') {
                <mat-label>{{ 'DOOR|Skracanie ościeżnicy:' | translate }}</mat-label>
              }
              @if (field.name == 'topLightSize') {
                <mat-label>{{ 'DOOR|Wysokość doświetla górnego:' | translate }}</mat-label>
              }
              @if (field.name == 'leftLightSize') {
                <mat-label>{{ 'DOOR|Szerokość doświetla lewego:' | translate }}</mat-label>
              }
              @if (field.name == 'rightLightSize') {
                <mat-label>{{ 'DOOR|Szerokość doświetla prawego:' | translate }}</mat-label>
              }
              <mat-select [formControlName]="field.field" [disabled]="field.disabled">
                @for (option of field.options; track option) {
                  <mat-option [value]="option.value">{{ option.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (field.value) {
            <span>
              <p>{{field.value}}</p>
              <span>{{ dimensionUnit.unitSymbol }}</span>
            </span>
          }
        }
      </form>
    </div>
  }
  @if (!hiddenSelectionsWithoutChange || !isFrameButton1Disabled()) {
    <icc-select-box
      [title]="('DOOR|Rodzaj ościeżnicy' | translate)"
      [infoContent]="isWysiwygEditorContentAvailable()"
      (showInfoContent)="clickShowInfoButton()"
      [description]="(getSelectedFrame())?.name || ('INTERFACE|Brak' | translate)"
      [imageUrl]="'/files/profile/' + ((getSelectedFrame())?.img || '')"
      [buttonText]="'INTERFACE|Zmień' | translate"
      (select)="changeFrame()"
      [disabledButton1]="isFrameButton1Disabled()"
    ></icc-select-box>
  }
  @if (!hiddenSelectionsWithoutChange || !isThresholdButton1Disabled()) {
    <icc-select-box
      [title]="('DOOR|Próg' | translate)"
      [description]="(selectedThreshold$ | async)?.name || ('INTERFACE|Brak' | translate)"
      [imageUrl]="'/files/profile/' + ((selectedThreshold$ | async)?.img || '')"
      [buttonText]="'INTERFACE|Zmień' | translate"
      (select)="changeThreshold()"
      [disabledButton1]="isThresholdButton1Disabled()"
    ></icc-select-box>
  }
  @if (!hiddenSelectionsWithoutChange || anyAvailableExtensions()) {
    <div class="box-form mat-elevation-z3">
      <button [disabled]="!anyAvailableExtensions()" mat-flat-button color="primary" (click)="changeExtensions()">{{ 'DOOR|Ustaw poszerzenia' | translate }}</button>
    </div>
  }
